import React from 'react'
import PropTypes from 'prop-types'

import { PrivacyPolicyAcceptanceTable } from '..'
import helpers from 'helpers'

const AcceptedByPrivacyPolicy = ({ privacyPolicies = [], ...rest }) => {
  const rows = helpers.myLgpd.mountAcceptanceRows({ privacyPolicies })

  return (
    <PrivacyPolicyAcceptanceTable
      title="Quantidade de Aceites por Documento"
      privacyPolicies={rows}
      {...rest}
    />
  )
}

AcceptedByPrivacyPolicy.propTypes = {
  privacyPolicies: PropTypes.array,
}

export default AcceptedByPrivacyPolicy
